import { Common } from '../common';
import {
  CreateValues,
  FindAllOptions,
  PrevisitLinkWithTemplates,
  UpdateValues,
} from '../models/previsit/link';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FindAllOptions): Promise<PrevisitLinkWithTemplates[]> {
    const url = this.common.constructPath(`/previsit/links`, options);
    return this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<PrevisitLinkWithTemplates> {
    const url = this.common.constructPath(`/previsit/links/${id}`);
    return this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<PrevisitLinkWithTemplates> {
    const url = this.common.constructPath(`/previsit/links`);
    return this.common.postJSON(url, values);
  }

  async update(
    id: string,
    values: UpdateValues,
  ): Promise<PrevisitLinkWithTemplates> {
    const url = this.common.constructPath(`/previsit/links/${id}`);
    return this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<void> {
    const url = this.common.constructPath(`/previsit/links/${id}`);
    return this.common.deleteJSON(url);
  }
}
